"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGoogleGeocode = exports.useGooglePlaces = void 0;
var js_api_loader_1 = require("@googlemaps/js-api-loader");
var react_1 = require("react");
var loader = null;
var STATE = {
    loading: false,
    places: null,
};
function loadPlaces(args) {
    if (STATE.loading || STATE.places) {
        if (STATE.places) {
            args.callback(STATE.places);
        }
        return;
    }
    if (!loader) {
        loader = new js_api_loader_1.Loader({
            apiKey: args.apiKey,
            version: "weekly",
            language: "sv",
            region: "SE",
            //...additionalOptions,
        });
    }
    STATE.loading = true;
    loader.importLibrary("places").then(function (places) {
        STATE.places = places;
        STATE.loading = false;
        args.callback(places);
    });
}
var useGooglePlaces = function (props) {
    var _a = (0, react_1.useState)(STATE.places), places = _a[0], setPlaces = _a[1];
    var apiKey = props.apiKey;
    (0, react_1.useEffect)(function () {
        if (!places) {
            loadPlaces({
                apiKey: apiKey,
                callback: setPlaces,
            });
        }
    }, [places, apiKey]);
    return places;
};
exports.useGooglePlaces = useGooglePlaces;
var useGoogleGeocode = function (props) {
    var places = (0, exports.useGooglePlaces)(props);
    var geocoder = (0, react_1.useMemo)(function () {
        if (!places) {
            return null;
        }
        return new google.maps.Geocoder();
    }, [places]);
    var getGeocode = (0, react_1.useCallback)(function (address) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!geocoder) {
                throw new Error("Geocoder not initialized");
            }
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    geocoder.geocode({ address: address }, function (results, status) {
                        if (status === google.maps.GeocoderStatus.OK && results) {
                            if (results.length === 0) {
                                reject("No results found");
                            }
                            else {
                                var result = results[0];
                                resolve(result);
                            }
                        }
                        else {
                            reject("Geocoding failed: " + status);
                        }
                    });
                })];
        });
    }); }, [geocoder]);
    return getGeocode;
};
exports.useGoogleGeocode = useGoogleGeocode;
